import { Users, ClipboardCheck, ShieldAlert, Server } from 'lucide-react';
import { IncidentTimeline } from '../components/IncidentTimeline';
import { MetricCard } from '../components/MetricCard';
import { useExam } from '../context/ExamContext';

export function AdminDashboardPage() {
  const { state } = useExam();
  return (
    <section className="mx-auto max-w-7xl px-4 py-8">
      <h1 className="text-4xl font-black text-white">Admin Dashboard</h1>
      <p className="mt-2 text-slate-400">Operational review space for risk, warnings, incidents, and session health.</p>
      <div className="mt-6 grid gap-4 md:grid-cols-4">
        <MetricCard label="Active Candidates" value="12" icon={<Users className="h-5 w-5" />} />
        <MetricCard label="Completed Exams" value="48" icon={<ClipboardCheck className="h-5 w-5" />} tone="green" />
        <MetricCard label="High Risk" value={state.incidents.filter((item) => item.severity === 'high' || item.severity === 'critical').length} icon={<ShieldAlert className="h-5 w-5" />} tone="red" />
        <MetricCard label="System Health" value="Good" icon={<Server className="h-5 w-5" />} tone="green" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_380px]">
        <div className="glass rounded-2xl p-5">
          <h2 className="font-semibold">Candidate Sessions</h2>
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="text-slate-400"><tr><th className="py-2">Candidate</th><th>Exam</th><th>Risk</th><th>Status</th></tr></thead>
              <tbody>
                {['Avery Stone', 'Mira Patel', 'Jon Chen', 'Sam Rivera'].map((name, index) => (
                  <tr key={name} className="border-t border-white/10">
                    <td className="py-3 font-semibold">{name}</td>
                    <td>MOCK-2026</td>
                    <td>{index === 0 ? state.metrics.riskScore : 12 + index * 9}</td>
                    <td>{index === 0 ? 'Live' : 'Submitted'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="glass rounded-2xl p-5">
          <h2 className="mb-4 font-semibold">Latest Incidents</h2>
          <IncidentTimeline incidents={state.incidents.slice(0, 6)} />
        </div>
      </div>
    </section>
  );
}
